import { useQuery } from '@tanstack/react-query'
import OrganizationAPI from '../api/organization.api'
import { QueryKeys } from './querykeys'

export const useQueryGetOrganizationTokensAvailable = (options?: { enabled?: boolean }) => {
  return useQuery({
    enabled: options?.enabled ?? true,
    queryKey: [QueryKeys.GET_ORGANIZATION_TOKENS_AVAILABLE],
    queryFn: () => OrganizationAPI.getTokensAvailable()
  })
}
